type LinkWithType<LinkType extends string> = {
  linkType?: LinkType | null;
};

/**
 * Checks whether a link's `linkType` matches one of the provided types.
 *
 * @param link - The link object to inspect. Returns `false` if `null`, `undefined`, or missing `linkType`.
 * @param types - One or more link type values to match against.
 * @returns `true` if `link.linkType` is present and included in `types`, otherwise `false`.
 *
 * @example
 * isLinkType(link, LINK_TYPES.ONLINE_DESIGNER)
 * isLinkType(link, LINK_TYPES.DOWNLOAD_APP, LINK_TYPES.DOWNLOAD_APP_DEEPLINK)
 */
export function isLinkType<LinkType extends string>(
  link: LinkWithType<LinkType> | undefined | null,
  ...types: LinkType[]
): boolean {
  if (!link?.linkType) {
    return false;
  }

  return types.includes(link.linkType);
}
